import React, { useEffect, useState } from "react";
import apiClient from "../../../utils/apiClient";
import StocksOptionsMuliplierDataTable from "./StocksOptionsMuliplierDataTable";
import server from "../../../utils/serverConfig";

export default function StockOptionsMultiplier() {
  const [stocksMultiplierData, setStocksMultiplierData] = useState([]);
  const [isStocksDataLoading, setIsStocksDataLoading] = useState(true);

  const fetchStocksMultiplierData = () => {
    setIsStocksDataLoading(true);
    let config = {
      method: "get",
      url: `${server.godseye.baseUrl}get-stocks-multiplier-data`,
    };

    apiClient
      .request(config)
      .then((response) => {
        // console.log("Stocks Multiplier Data", response.data);
        setStocksMultiplierData(response.data?.data || []);
        setIsStocksDataLoading(false);
      })
      .catch((error) => {
        console.log(error);
        setStocksMultiplierData([]);
        setIsStocksDataLoading(false);
      });
  };

  const handleEditStockOptionsConfig = (
    clientId,
    stocksMultiplier,
    stocksConfig
  ) => {
    console.log("Client Id", clientId);
    console.log("New stock Multiplier", stocksMultiplier);
    console.log("New stock config", stocksConfig);

    let config = {
      method: "POST",
      url: `${server.godseye.baseUrl}update-stocks-options-multiplier`,
      data: {
        clientId: clientId,
        stocksMultiplier: Number(stocksMultiplier),
        stocksConfig: stocksConfig,
      },
    };

    apiClient
      .request(config)
      .then((response) => {
        console.log("Response is ---->", response);
        fetchStocksMultiplierData();
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    fetchStocksMultiplierData();
  }, []);

  return (
    <div className="flex flex-col relative  w-full max-h-screen">
      <div className="flex items-center justify-between space-x-4 ">
        <div className="flex justify-between items-center h-[40px] px-6 w-full">
          <p className="flex items-center text-lg font-semibold text-white">
            Stock Options Multiplier
          </p>
        </div>
      </div>

      <div className="flex h-full flex-col relative w-full">
        {isStocksDataLoading ? (
          <div className="flex items-center justify-center text-[20px] text-white font-medium w-full h-[calc(100vh-210px)]">
            loading....
          </div>
        ) : !isStocksDataLoading && stocksMultiplierData?.length === 0 ? (
          <div className="flex items-center justify-center text-[20px] text-white font-medium w-full h-[calc(100vh-210px)]">
            No Data Found
          </div>
        ) : (
          <div className="flex min-w-full pt-2">
            <StocksOptionsMuliplierDataTable
              stocksMultiplierData={stocksMultiplierData}
              handleEditStockOptionsConfig={handleEditStockOptionsConfig}
            />
          </div>
        )}
      </div>
    </div>
  );
}
